import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="border_subtitle">This tool can help</div>
                                            <p>It’s often hard to take time out of our busy lives to reflect and
                                                consider what is it that we really want, who we want to be and
                                                what is really important to us. This tool is about <span
                                                    className="brown brownbold"> how to identify your personal meaning </span> and
                                                highlights the importance of being aware of your core values and
                                                personal preferences. Knowledge of these core concepts can help
                                                you to understand what you want from your work and how to go
                                                about getting it.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">PERSONAL MEANING DECONSTRUCTED</span>
                                            </div>

                                            <p>There is so much going on around us and we are subject to so many
                                                external influences that, sometimes, it can be hard to identify
                                                your own direction or core identity in life. Understanding who
                                                you are and what really matters to you is about identifying your
                                                ‘personal meaning’. At first, this might seem a little obscure –
                                                a bit like trying to describe ‘the real me’ in one easy
                                                sentence!</p>
                                            <p>However, its relevance in the workplace is that whomever you
                                                believe yourself to be and what your personal ethics are is
                                                likely to determine the way in which you behave and interact
                                                with others. It also has a bearing, therefore, on your own
                                                alignment or otherwise with the job you do and the overall goals
                                                and objectives of the organisation which employs you.</p>
                                            <p>People often begin their job motivated and invest considerable
                                                effort in it but, for some, this dwindles. So, ask yourself why
                                                you do what you do. Whatever your personal circumstances, it’s
                                                always useful to reflect on what’s really important to you, who
                                                you are and what you want. We can’t promise too much, but as a
                                                starting point this tool is designed to give you a little more
                                                personal insight about what matters most to you.</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">THE FOUR UNDERLYING CONCEPTS</span>
                                            </div>

                                            <div className="border_subtitle">Personal meaning constitutes these
                                                four, separate concepts:
                                            </div>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/descrip_img.png')}
                                                    alt="" className=""/>
                                            </div>
                                            <div className="buttonposition">
                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page1')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}